import React from 'react'
import Typography from '@mui/material/Typography'
import Paper from '@mui/material/Paper'

import Heading from '~/client/components/Heading'
import ChangePasswordForm from '~/client/components/ChangePasswordForm'

export default function Page() {
  return <>
    <Paper sx={{p: 2, my: 2}}>
      <Heading variant="sub" underlined>Change Password</Heading>
      <ChangePasswordForm/>
    </Paper>
    <Paper sx={{p: 2, my: 2}}>
      <Heading variant="sub" underlined>Two-factor Authentication</Heading>
      <Typography variant="body2">Coming soon…</Typography>
    </Paper>
  </>
}
